import axios from 'axios'
import { useState } from 'react'
import logger from '~/src/lib/logger'

const useSubmitIssue = () => {
  const [processing, setProcessing] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [initialIssueSubmitted, setInitialIssueSubmitted] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const submit = async (data: {
    hash?: string | null
    tempUserId?: string | null
    userContact?: string | null
    metadata: Record<string, unknown>
  }) => {
    if (processing || submitted) return

    setProcessing(true)
    try {
      const resp = await axios.post('/api/issue', data)

      if (resp.status === 200) {
        if (data?.userContact) {
          setSubmitted(true)
        } else {
          setInitialIssueSubmitted(true)
        }
      }
    } catch (e: any) {
      logger.error('Error sending user result issue', {
        data,
        error: e,
      })
      setError(e)
    } finally {
      setProcessing(false)
    }
  }

  return {
    processing,
    initialIssueSubmitted,
    submitted,
    error,
    submit,
  }
}

export default useSubmitIssue
